import moment from 'moment';


const limitDate = {
    limitMinDate : "2001-01-01",
    limitMaxDate : moment().add(1,'y').format('YYYY-MM-DD')

}


export default limitDate